export enum UserStatus {
  ACTIVE = 2,
  INVITED = 1,
}

export const UserStatusNames = {
  [UserStatus.ACTIVE]: 'Active',
  [UserStatus.INVITED]: 'Invited',
}
